import { EyeFilled, EyeInvisibleFilled } from "@ant-design/icons";
import React, { useState } from "react";
import styled from "styled-components";
import { COLORS } from "../../constants/colors";
import { EditTextType } from "../../types/AllTypes";


interface Props {
    active: boolean;
    Icon?: React.ReactNode;
    borderColor: string;
    textColor: string;
    value: string;
    onChange: any;
    name: string;
    placeholder: string;
    backgroundcolor: string;
    props?: any;
    type: EditTextType;
    decimalOrInteger?: 'decimal' | 'integer';
    inForm?: boolean;
}

const InputWrapper = styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${(props) => props.backgroundcolor};
    border-radius: 5px;
    border: 1px solid ${(props) => props.borderColor};
    

     .input{
        background-color: ${COLORS.transparent_color1} !important;
        border: none;
        outline: none !important;
        width: 100%;
        padding-right: 5px;
        padding-left: 8px;
        font-size: 1.1em;
        font-weight: 300;
        height: 38px;
        color: ${(props) => props.textColor} !important;
    }


     .input::placeholder {
        color: ${(props) => props.borderColor};
        font-weight: 300;
        opacity: 0.5;
        font-size: 1em;
    }
    
    .icon {
        color: ${(props) => props.borderColor};
        font-size: 20px;
        opacity: 0.8;
        margin-left: 10px;
    }

     .icon2 {
        color: ${(props) => props.borderColor};
        font-size: 18px;
        opacity: 0.4;
        cursor: pointer;
        margin-left: 10px;
        margin-right: 8px;
        transition: all 0.2s;
    }

    .icon2:hover {
        opacity: 0.8;
    }

    `;

const EditTextForm = ({ borderColor, textColor, backgroundcolor, active, value, onChange, name, props, placeholder, Icon, inForm = true, type, decimalOrInteger = 'integer' }: Props): JSX.Element => {
    const [isPass, setIsPass] = useState<boolean>(type === 'password' ? true : false);
    const [canWrite, setCanWrite] = useState<boolean>(true);

    return (
        <InputWrapper {...props} borderColor={borderColor} textColor={textColor} backgroundcolor={active ? backgroundcolor : COLORS.black_back_color5} active={active} value={value}>
            {!!Icon &&
                <nav className="icon">{Icon}</nav>
            }
            {type === 'textarea' &&
                <textarea name={name} onChange={inForm ? onChange : (e) => onChange(e.target.value.toString())} disabled={active ? false : true} value={value} className="input" placeholder={placeholder} rows={15} />
            }

            {type === 'password' &&
                <>
                    <input type={isPass ? 'password' : 'text'} name={name} onChange={inForm ? onChange : (e) => onChange(e.target.value.toString())} disabled={active ? false : true} value={value} className="input" placeholder={placeholder} />
                    <nav className="icon2" onClick={() => setIsPass(!isPass)}>{!isPass ? <EyeFilled /> : <EyeInvisibleFilled />}</nav>
                </>
            }

            {type === 'text' &&
                <input type={'text'} name={name} onChange={inForm ? onChange : (e) => onChange(e.target.value.toString())} disabled={active ? false : true} value={value} className="input" placeholder={placeholder} />
            }

            {type === 'number' &&
                <input type={'text'} pattern={decimalOrInteger === 'integer' ? "[0-9]*" : "[0-9]+([\.])?[0-9]*"} name={name} onChange={inForm ? ((e) => e.target.validity.valid ? onChange(e) : null) : ((e) => e.target.validity.valid ? onChange(e.target.value.toString()) : null)} disabled={active ? false : true} value={value} className="input" placeholder={placeholder} />
            }

            {type === 'date' &&
                <input type={'date'} onKeyDown={() => setCanWrite(false)} onKeyUp={() => setCanWrite(true)} name={name} /*min={`${new Date().getFullYear()}-${(new Date().getMonth() + 1) < 10 ? '0' : ''}${new Date().getMonth() + 1}-${new Date().getDate() < 10 ? '0' : ''}${new Date().getDate()}`}*/ onChange={inForm ? (canWrite ? onChange : null) : (e) => (canWrite ? onChange(e.target.value.toString()) : null)} disabled={active ? false : true} value={value} className="input" placeholder={placeholder} />
            }

            {type === 'datetime-local' &&
                <input type={'datetime-local'} name={name} /*min={new Date().toISOString().split('Z')[0]}*/ onChange={inForm ? (canWrite ? onChange : null) : (e) => (canWrite ? onChange(e.target.value.toString()) : null)} disabled={active ? false : true} value={value} className="input" placeholder={placeholder} />
            }

            {type === 'time' &&
                <input type={'time'} name={name} onChange={inForm ? (canWrite ? onChange : null) : (e) => (canWrite ? onChange(e.target.value.toString()) : null)} value={value} className="input" placeholder={placeholder} />
            }
        </InputWrapper>
    );
}

export default EditTextForm;